import React, { useContext, useState } from 'react';

import * as S from './styles';
import Modal from 'components/Modal';
import { BlogProps } from 'types/BlogProps';
import SimpleInput from 'components/SimpleInput';
import { generateUid } from 'utils/functions';
import TitleForm from 'components/TitleForm';
import CreateContentWithImg from 'components/CreateContentWithImg';
import { addBlog, editBlog } from './reqs';
import SystemNotifyContext from 'context/SystemNotifyContext';
import LoadGeneralContext from 'context/LoadGeneralContext';
import { saveOrderReq } from 'pages/Blog/reqs';

const intialDataForm: BlogProps = {
	id: generateUid(),
	urlVideo: '',
	date: '',
	title: '',
	subtitle: '',
	position: 0,
	content: []
};

interface FormBlogProps {
	isOpenForm: boolean;
	setIsOpenForm: React.Dispatch<React.SetStateAction<boolean>>;
	blogToEdit: BlogProps | null;
	blogs: BlogProps[];
	setBlogs: React.Dispatch<React.SetStateAction<BlogProps[]>>;
	resetFunction: () => void;
	setIsLoad: React.Dispatch<React.SetStateAction<boolean>>;
}

export default function FormBlog({
	isOpenForm,
	setIsOpenForm,
	blogToEdit,
	resetFunction,
	blogs,
	setBlogs,
	setIsLoad
}: FormBlogProps) {
	const { handleNotify } = useContext(SystemNotifyContext);
	const { setIsOpenLoad, setMessage } = useContext(LoadGeneralContext);

	const [dataForm, setDataForm] = useState(
		blogToEdit
			? blogToEdit
			: {
					...intialDataForm,
					position: blogs[blogs.length - 1]?.position + 1 || 1
				}
	);

	async function saveBlog() {
		if (dataForm.title === '') {
			handleNotify('O título é obrigatório.', 'warning');
			return;
		}

		if (dataForm.subtitle === '') {
			handleNotify('O subtítulo é obrigatório.', 'warning');
			return;
		}

		if (dataForm.date === '') {
			handleNotify('A data é obrigatória.', 'warning');
			return;
		}

		if (dataForm.urlVideo === '') {
			handleNotify('A URL do vídeo principal é obrigatória.', 'warning');
			return;
		}

		if (dataForm.content.length === 0) {
			handleNotify('Adicione pelo menos 1 conteúdo.', 'warning');
			return;
		}

		setIsOpenLoad(true);

		if (blogToEdit === null) {
			setMessage('Adicionando blog...');
			await addBlog(dataForm, setBlogs, setIsLoad, blogs.length, handleNotify);
		} else {
			setMessage('Editando blog...');

			await saveOrderReq(blogs, handleNotify, false);
			await editBlog(
				dataForm,
				blogToEdit,
				setBlogs,
				setIsLoad,
				blogs,
				handleNotify
			);
		}

		setIsOpenLoad(false);
		resetFunction();
	}

	return (
		<Modal
			isOpenProps={isOpenForm}
			setIsOpenModal={() => {
				setIsOpenForm((value) => !value);
				resetFunction();
			}}
			title={blogToEdit ? 'Editar blog' : 'Adicionar blog'}
			buttonClose={false}
		>
			<S.container>
				<S.box>
					<S.forms>
						<TitleForm title="Dados principais">
							<S.gapDiv>
								<S.twoInputsRow>
									<SimpleInput
										label="Título"
										initialValue={dataForm.title}
										getValue={(value: string) => {
											setDataForm((obj) => ({ ...obj, title: value }));
										}}
									/>

									<SimpleInput
										label="Subtítulo"
										initialValue={dataForm.subtitle}
										getValue={(value: string) => {
											setDataForm((obj) => ({ ...obj, subtitle: value }));
										}}
									/>
								</S.twoInputsRow>

								<S.twoInputsRow>
									<SimpleInput
										paddingInLineEnd
										label="Data de criação"
										typeInput="date"
										initialValue={dataForm.date}
										getValue={(value: string) => {
											setDataForm((obj) => ({
												...obj,
												date: value
											}));
										}}
									/>
									<SimpleInput
										label="URL do vídeo principal"
										initialValue={dataForm.urlVideo}
										getValue={(value: string) => {
											setDataForm((obj) => ({ ...obj, urlVideo: value }));
										}}
									/>
								</S.twoInputsRow>
							</S.gapDiv>
						</TitleForm>

						<TitleForm title="Conteúdo">
							<CreateContentWithImg
								getContents={(contents) => {
									setDataForm((obj) => ({ ...obj, content: contents }));
								}}
								textBtn="Adicionar conteúdo"
								contents={dataForm.content}
							/>
						</TitleForm>
					</S.forms>
				</S.box>

				<S.containerBtns>
					<S.cancel
						data-testid="cancelBtn"
						onClick={() => {
							resetFunction();
						}}
					>
						Cancelar
					</S.cancel>
					<S.save
						data-testid="saveBtn"
						onClick={async () => {
							await saveBlog();
						}}
					>
						Salvar
					</S.save>
				</S.containerBtns>
			</S.container>
		</Modal>
	);
}
